//lib
import { useFormikContext } from "formik";
import {
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
} from "mdb-react-ui-kit";

//component
import Row from "./row";
import Col from "./col";

export default function Dropdown({
  label,
  name,
  options,
  placeholder,
  className,
  onClick,
  isRequired,
  field,
  form,
}) {
  let formik = useFormikContext(); // always called

  let isFormik = !!(formik && formik.values && name);
  let value = isFormik ? formik.values[name] : "";
  let errors = isFormik ? formik.errors || {} : {};


  return (
    <>
      <Col className={`element _dropdown ${className ? className : ""}`}>
        {label && (
          <Row>
            <label>
              {label} {isRequired && <span>*</span>}
            </label>
          </Row>
        )}
        <Row>
          <MDBDropdown className={value ? "active" : ""}>
            <MDBDropdownToggle type="button">
              {name && value && options?.length > 0
                ? options.find((opt) => opt.value === value)?.label
                : placeholder
                ? placeholder
                : "Select Options"}
            </MDBDropdownToggle>
            <MDBDropdownMenu>
              {options &&
                options.map((option, index) => (
                  <MDBDropdownItem
                    key={index}
                    onClick={() => {
                      if (onClick) {
                        onClick(option.value);
                      }

                      formik?.setFieldValue(name, option.value);
                    }}
                  >
                    {option.label}
                  </MDBDropdownItem>
                ))}
            </MDBDropdownMenu>
          </MDBDropdown>
        </Row>
      </Col>
      {errors && errors[name] ? (
        <Row className="element _errors">{errors[name]}</Row>
      ) : null}
    </>
  );
}
